import { AuthController } from "@somewear/auth";
import { RenderIf } from "@somewear/ui";
import type { IErrorLoading } from "@web/common/Common";
import * as Common from "@web/common/Common";
import Paths from "@web/common/Paths";
import type PhoneInputController from "@web/common/PhoneInputController";
import PhoneInputView from "@web/common/PhoneInputView";
import * as React from "react";
import { Link } from "react-router-dom";

import * as LandingCommon from "./LandingCommon";

interface IProps extends IErrorLoading {
	phoneInputController: PhoneInputController;
	solveCaptcha(evt: React.FormEvent<HTMLButtonElement>): void;
	hideSignOut?: boolean;
}

const PhoneView: React.FunctionComponent<IProps> = (props: IProps) => (
	<div className="mx-2 w-full md:w-auto md:min-w-96">
		<form>
			<LandingCommon.CenterHeader text="What's your phone number?" />
			<div className="mx-2 md:mx-10">
				<LandingCommon.ErrorMessage error={props.error} />
				<LandingCommon.FirstInput error={props.error}>
					<PhoneInputView
						country="US"
						placeholder="Phone number"
						className="w-full mb-4"
						value={props.phoneInputController.getValue()}
						controlledInput={props.phoneInputController}
					/>
				</LandingCommon.FirstInput>
				<Common.CenterContent>
					<LandingCommon.Button onClick={(evt) => props.solveCaptcha(evt)}>
						<Common.TitleButtonText>Send SMS</Common.TitleButtonText>
					</LandingCommon.Button>
				</Common.CenterContent>
			</div>
			<RenderIf condition={Boolean(props.hideSignOut)}>
				<Common.CenterContent>
					<Link to={Paths.Root}>
						<LandingCommon.LinkButton className="mt-2.5">Back</LandingCommon.LinkButton>
					</Link>
				</Common.CenterContent>
			</RenderIf>
			<Common.CenterContent>
				<div className="text-sm text-gray-600 text-center mt-10 md:mt-0 mb-5 md:mb-0 static md:fixed md:bottom-5 tracking-wide leading-tight">
					Need an account?
					<Link to={Paths.Signup}>
						<span className="text-blue-500 font-bold cursor-pointer uppercase">
							{" "}
							Sign up{" "}
						</span>
					</Link>
				</div>
			</Common.CenterContent>
			<RenderIf condition={!props.hideSignOut}>
				<Common.CenterContent>
					<div className="text-sm tracking-wide fixed bottom-12 text-blue-500 cursor-pointer">
						<span
							onClick={() => {
								AuthController.service?.signOut$().subscribe();
							}}
						>
							{" "}
							LOGOUT
						</span>
					</div>
				</Common.CenterContent>
			</RenderIf>
		</form>
	</div>
);

export default PhoneView;
